__turbopack_context__.v({
  "activeCodeLabel": "pjW6-a_activeCodeLabel",
  "activeCodeRemoveButton": "pjW6-a_activeCodeRemoveButton",
  "activeCodeTitle": "pjW6-a_activeCodeTitle",
  "activeCodeWrapper": "pjW6-a_activeCodeWrapper",
  "onlyDesktopContent": "pjW6-a_onlyDesktopContent",
});
